import { render, staticRenderFns } from "./item.vue?vue&type=template&id=2c50911d&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=2c50911d&prod&lang=scss&scoped=true"
import style1 from "./item.vue?vue&type=style&index=1&id=2c50911d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50911d",
  null
  
)

export default component.exports